import { render, staticRenderFns } from "./EstablishmentsEdit.vue?vue&type=template&id=a1f3ad1c&"
import script from "./EstablishmentsEdit.vue?vue&type=script&lang=js&"
export * from "./EstablishmentsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports